// Include jQuery
const $ = require('jquery');

// jQuery definitions
window.jQuery = $;
window.$ = $;

import autocomplete from 'autocompleter';

/**
 * Remove all chips from Autocomplete
 * @param element
 * @returns {boolean}
 */
window.resetChips = function(element) {
  const chipWrap = $(element).closest('form').find('.chips');
  chipWrap.find('.chip').remove();

  const checkboxes = $(element).closest('form').find('input[type="checkbox"]');
  checkboxes.prop('checked', false);

  const dateInputs = $(element).closest('form').find('input[type="date"]');
  dateInputs.val('');
  return false;
};

/**
 * resetCheckboxes
 * @param element
 * @returns {boolean}
 */
window.resetCheckboxes = function(element) {
  $(element).closest('form').find('input[type="checkbox"]').prop('checked', false);

  return false;
};

/**
 * Remove single chip
 * @param element
 * @returns {boolean}
 */
window.removeChip = function(element) {
  $(element).closest('.chip').remove();

  return false;
};

/**
 * Autocomplete
 * @param elementID
 * @param helperFile
 * @param additionalElement
 * @param fillHiddenField
 * @param preViewName
 * @param completeHelperFile
 */
window.autocompleteView = function(elementID, helperFile, additionalElement = '', fillHiddenField = false, preViewName = '', completeHelperFile = '') {
  // input
  const input = document.getElementById(elementID);
  input.setAttribute('autocomplete', 'off');

  // chips
  const chipWrap = $(input).closest('.form-field--chip-wrap').find('.chips');

  autocomplete({
    emptyMsg: LANG_STRINGS.noResults, // eslint-disable-line
    minLength: 1,
    input: input,
    showOnFocus: true,
    preventSubmit: 'Never',
    fetch: function(text, update) {
      text = text.toLowerCase();

      // chips
      let chipList = [];
      const chipElements = chipWrap.find('.chip');
      if (chipElements.length > 0) {
        chipElements.each(function() {
          chipList.push($(this).find('input[type="hidden"]').val());
        });
      }

      let additionalData = [];
      if (additionalElement !== '') {
        const additionalElementData = $(input).closest('form').find(additionalElement);
        if (additionalElementData.length > 0) {
          additionalData.push(additionalElementData.val());
        }
      }

      // Ajax-Call
      $.ajax({
        url: (completeHelperFile ? completeHelperFile : BASE_PATH + 'ajax/autocomplete/' + helperFile), // eslint-disable-line
        type: 'post',
        data: {
          type: elementID,
          search: text,
          chips: chipList,
          additionalData: additionalData,
        },
        dataType: 'json',
        success: function(suggestions) {
          update(suggestions);
        },
      });
    },
    customize: function(input, inputRect, container) {
      const htmlElement = document.documentElement;
      const zoomboxOverlay = document.querySelector('.zoombox-overlay.has-sidebar');
      if (zoomboxOverlay) {
        const topValue = Math.abs(parseInt(getComputedStyle(htmlElement).getPropertyValue('top')));
        const containerTopValue = parseInt(getComputedStyle(container).getPropertyValue('top'));
        if (topValue) {
          container.style.top = (containerTopValue + topValue) + 'px';
        }
      }
    },
    onSelect: function(item) {
      if (chipWrap.length > 0) {
        chipWrap.append('<span class="chip"><span>' + item.label + '</span><i class="material-icons" onclick="removeChip(this);">cancel</i><input type="hidden" name="' + (preViewName !== '' ? preViewName : 'view[' + elementID + '][]') + '" value="' + item.value + '"></span>');
        input.value = '';
        input.blur();
        input.focus();
      } else {
        if (fillHiddenField === true) {
          $(input).next('input[type=hidden]').val(item.value);
          input.value = item.label;
        } else {
          input.value = item.value;
          input.label = item.value;
        }
      }
    },
  });

  // Enter-Verhalten unterdrücken, wenn Vorschläge offen sind
  input.addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      return false;
    }
  });
};
